import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  ID3lnbkn76l7dgd as ID,
  CareLocationProgrameuu05ugy00sb as CareLocationProgram,
  ID3j2ictjlq95nd as ID_0,
  CareLocationProgramDated2hjmsy0f9azw0 as CareLocationProgramDated,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_templateSince32usg3af6gzni as get_templateSince,
  get_template1m0dwy8u7b927 as get_template,
  get_program2j5nucnpibn8o as get_program,
  get_activeRange1133ufp87xqbu as get_activeRange,
  get_start30tbw38mnjak0 as get_start,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  nowLocal2mdv5rmil2cf2 as nowLocal,
  today1rno4frfjp5oe as today,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  keyValue1ck7xpd7fxylw as keyValue,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
} from '../components/view-utilities.mjs';
import { renderToString1uchiuvkjsib7 as renderToString } from '../../utils/daterender.mjs';
import { Cents__toString$default_impl_dffhixgwhghxlriorf as Cents__toString$default_impl_dffhix } from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { ID1z61wlmtvxrjn as ID_1 } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { CareProgramTemplateDetailPagec1d9jyccm55e as CareProgramTemplateDetailPage } from './CareRateTemplateDetailPage.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  styledHeaderwng1nfqibdig as styledHeader,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function LocationRatePage$render$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateLocationLabel_u8i4x6_k$();
}
function LocationRatePage$render$lambda_0($this$inlineLabel) {
  return $this$inlineLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_ratePlanLabel_6i1kny_k$();
}
function LocationRatePage$render$lambda_1($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function LocationRatePage$render$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateChangeButton_dchwaz_k$();
}
function LocationRatePage$render$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateStartingAtDateLabel_5za9na_k$();
}
function LocationRatePage$render$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateToRateLabel_vgzx2o_k$();
}
function LocationRatePage$render$slambda$lambda$lambda_1(it) {
  return it.name_1;
}
function Checkbox$_get_enabled_$ref_57hbqa(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 206, VOID, [p0]);
}
function Checkbox$_set_enabled_$ref_zhvi26(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 207, VOID, [p0]);
}
function LocationRatePage$render$slambda$lambda$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function LocationRatePage$render$slambda$lambda$slambda($closer) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    $closer();
    return Unit_instance;
  }), 1);
}
function LocationRatePage$render$slambda$lambda$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateChangeButton_dchwaz_k$();
}
function LocationRatePage$render$slambda$lambda$slambda_0(this$0, $date, $targetRate, $closer) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).get_careLocationPrograms_g0oima_k$().get_6ueaa7_k$(new (ID())(this$0.id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_1 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationProgram()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$5);
    var tmp_1 = get_templateSince(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $date;
    var tmp0_elvis_lhs = yield* await_1(this_2, $completion);
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    this_1.assign_vtsfu6_k$(tmp_1, tmp_2);
    var tmp_3 = get_template(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $targetRate;
    var tmp$ret$8 = yield* await_1(this_3, $completion);
    this_1.assign_vtsfu6_k$(tmp_3, new (ID_0())(tmp$ret$8._id_1));
    var tmp$ret$1 = this_1.build_1k0s4u_k$();
    yield* tmp.modify_ff53f_k$(tmp$ret$1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_currentSessionNotNull();
    yield* (yield* await_0(this_4, $completion)).get_careLocationProgramDateds_xnbfxu_k$().totallyInvalidate_d4stw5_k$($completion);
    $closer();
    return Unit_instance;
  }), 1);
}
function LocationRatePage$render$slambda(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.plan_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    var targetRate = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
    var date = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(nowLocal().get_date_wokkxj_k$());
    var ready = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, closer) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(30));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).rateChangePlanTitle_kxriyt_k$($this$invoke.invoke_r7m7el_k$(this$0.rate_1).name_1));
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element.willAddChild_hz2iwc_k$(element_1);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_1);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_1));
      element_1.invoke_bnq13k_k$(tmp_4, LocationRatePage$render$slambda$lambda$lambda);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
      var this_1 = themed(element_1, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (LocalDateField())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_1.willAddChild_hz2iwc_k$(element_2);
      element_2.bind_gesskf_k$(element_2.content_1, date);
      element_2.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_2);
      errorText(element_1);
      element_1.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element.willAddChild_hz2iwc_k$(element_3);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = LabeledView$_get_content_$ref_5yojet(element_3);
      var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, LabeledView$_set_content_$ref_ys1c8f(element_3));
      element_3.invoke_bnq13k_k$(tmp_7, LocationRatePage$render$slambda$lambda$lambda_0);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.select' call
      var this_2 = themed(element_3, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (Select())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_2.willAddChild_hz2iwc_k$(element_4);
      var tmp_8 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
        var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplates_ojj53j_k$();
        var tmp_0 = new (Query())();
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance_0();
        var tmp_1 = toDuration(0, DurationUnit_MINUTES_getInstance());
        // Inline function 'kotlin.time.Companion.minutes' call
        Companion_getInstance_0();
        var tmp$ret$25 = toDuration(10, DurationUnit_MINUTES_getInstance());
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = $this$remember.invoke_r7m7el_k$(tmp.list_wx6i37_k$(tmp_0, tmp_1, tmp$ret$25));
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (element.careTime_1.equals($this$remember.invoke_r7m7el_k$(this$0.rate_1).careTime_1)) {
            destination.add_utx5q5_k$(element);
          }
        }
        return destination;
      });
      element_4.bind_64a41i_k$(targetRate, tmp_8, LocationRatePage$render$slambda$lambda$lambda_1);
      element_4.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_4);
      errorText(element_3);
      element_3.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      element.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      var this_3 = get_centered(element_5);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (Checkbox())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_3.willAddChild_hz2iwc_k$(element_6);
      var tmp_9 = KMutableProperty0();
      var tmp_10 = Checkbox$_get_enabled_$ref_57hbqa(element_6);
      var tmp_11 = getPropertyCallableRef('enabled', 0, tmp_9, tmp_10, Checkbox$_set_enabled_$ref_zhvi26(element_6));
      element_6.invoke_bnq13k_k$(tmp_11, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(date) == null) && !$this$invoke.invoke_r7m7el_k$(targetRate).equals($this$invoke.invoke_r7m7el_k$(this$0.plan_1)));
      element_6.bind_gesskf_k$(element_6.checked_1, ready);
      element_6.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_6);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var this_4 = get_centered(element_5);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_5 = weight(this_4, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (TextView())(this_5.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      this_5.willAddChild_hz2iwc_k$(element_7);
      var tmp_12 = KMutableProperty0();
      var tmp_13 = TextView$_get_content_$ref_4pzcwl(element_7);
      var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb(element_7));
      element_7.invoke_bnq13k_k$(tmp_14, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).rateChangeConfirmation_752i51_k$($this$invoke.invoke_r7m7el_k$(targetRate).name_1));
      element_7.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_7);
      element_5.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_5);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      element.willAddChild_hz2iwc_k$(element_8);
      element_8.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_8);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      element.willAddChild_hz2iwc_k$(element_9);
      element_9.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_6 = themed(element_9, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (Button())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      this_6.willAddChild_hz2iwc_k$(element_10);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_7 = get_centered(element_10);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_11 = new (TextView())(this_7.get_context_h02k06_k$());
      ensureOutermostElement(element_11);
      this_7.willAddChild_hz2iwc_k$(element_11);
      var tmp_15 = KMutableProperty0();
      var tmp_16 = TextView$_get_content_$ref_4pzcwl(element_11);
      var tmp_17 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb(element_11));
      element_11.invoke_bnq13k_k$(tmp_17, LocationRatePage$render$slambda$lambda$lambda_2);
      element_11.onStartup_vrxh3i_k$();
      this_7.addChild_2qpft2_k$(element_11);
      element_10.set_action_2ds022_k$(Action('Cancel', VOID, VOID, VOID, VOID, VOID, LocationRatePage$render$slambda$lambda$slambda(closer)));
      element_10.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_10);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_8 = weight(element_9, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_12 = new (Space())(this_8.get_context_h02k06_k$());
      ensureOutermostElement(element_12);
      this_8.willAddChild_hz2iwc_k$(element_12);
      element_12.onStartup_vrxh3i_k$();
      this_8.addChild_2qpft2_k$(element_12);
      // Inline function 'com.lightningkite.kiteui.views.danger' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_9 = themed(element_9, DangerSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_10 = themed(this_9, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_13 = new (Button())(this_10.get_context_h02k06_k$());
      ensureOutermostElement(element_13);
      this_10.willAddChild_hz2iwc_k$(element_13);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_11 = get_centered(element_13);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_14 = new (TextView())(this_11.get_context_h02k06_k$());
      ensureOutermostElement(element_14);
      this_11.willAddChild_hz2iwc_k$(element_14);
      var tmp_18 = KMutableProperty0();
      var tmp_19 = TextView$_get_content_$ref_4pzcwl(element_14);
      var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb(element_14));
      element_14.invoke_bnq13k_k$(tmp_20, LocationRatePage$render$slambda$lambda$lambda_3);
      element_14.onStartup_vrxh3i_k$();
      this_11.addChild_2qpft2_k$(element_14);
      var tmp_21 = KMutableProperty0();
      var tmp_22 = Button$_get_enabled_$ref_61t7nx(element_13);
      var tmp_23 = getPropertyCallableRef('enabled', 0, tmp_21, tmp_22, Button$_set_enabled_$ref_o8kynz(element_13));
      element_13.invoke_bnq13k_k$(tmp_23, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(date) == null) && $this$invoke.invoke_r7m7el_k$(ready) && !$this$invoke.invoke_r7m7el_k$(targetRate).equals($this$invoke.invoke_r7m7el_k$(this$0.plan_1)));
      element_13.set_action_2ds022_k$(Action('Change', VOID, VOID, VOID, VOID, VOID, LocationRatePage$render$slambda$lambda$slambda_0(this$0, date, targetRate, closer)));
      element_13.onStartup_vrxh3i_k$();
      this_10.addChild_2qpft2_k$(element_13);
      element_9.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_9);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function LocationRatePage$render$lambda_3($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateOnThisPlanSinceLabel_vdwh5j_k$();
}
function LocationRatePage$render$lambda_4($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCurrentRateHeading_hraq4y_k$();
}
function LocationRatePage$render$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateLocationCurrentRateSubtext_i30vi_k$();
}
function LocationRatePage$render$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCurrentChip_ej3r0k_k$();
}
function LocationRatePage$render$lambda_7($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function LocationRatePage$render$lambda_8($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function LocationRatePage$render$lambda_9($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function LocationRatePage$render$lambda_10($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateHistoryHeading_245zkn_k$();
}
function LocationRatePage$render$lambda_11($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateHistorySubtext_t3uw1u_k$();
}
function LocationRatePage$render$lambda_12($this$table, current) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())($this$table.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$table.willAddChild_hz2iwc_k$(element);
  element.set_action_2ds022_k$(Action('Detail', VOID, VOID, VOID, VOID, VOID, LocationRatePage$render$lambda$slambda(element, current)));
  element.onStartup_vrxh3i_k$();
  $this$table.addChild_2qpft2_k$(element);
  return element;
}
function LocationRatePage$render$lambda$slambda$lambda$lambda($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function LocationRatePage$render$lambda$slambda$lambda$lambda_0($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function LocationRatePage$render$lambda$slambda$lambda$lambda_1($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function LocationRatePage$render$lambda$slambda($$this$button, $current) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, it) => {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth());
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = themed(this_0, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_1.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_2 = weight(element_0, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Space())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_2.willAddChild_hz2iwc_k$(element_1);
      element_1.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_3 = get_centered(element_0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_3.willAddChild_hz2iwc_k$(element_2);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString($this$invoke, $this$invoke.invoke_r7m7el_k$($current).activeRange_1));
      element_2.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_2);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      var tmp_2 = LocationRatePage$render$lambda$slambda$lambda$lambda;
      keyValue(element, tmp_2, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).price_1, VOID, true));
      var tmp_3 = LocationRatePage$render$lambda$slambda$lambda$lambda_0;
      keyValue(element, tmp_3, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).transportOneWay_1, VOID, true));
      var tmp_4 = LocationRatePage$render$lambda$slambda$lambda$lambda_1;
      keyValue(element, tmp_4, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$($current).transportTwoWay_1, VOID, true));
      element.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function LocationRatePage$render$lambda_13($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateInForceColumnLabel_elll5r_k$();
}
function LocationRatePage$render$lambda_14($this$text, it) {
  return it.activeRange_1.toString();
}
function LocationRatePage$render$lambda_15($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function LocationRatePage$render$lambda_16($this$custom, dated) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(dated).price_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function LocationRatePage$render$lambda_17($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function LocationRatePage$render$lambda_18($this$custom, version) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(version).transportOneWay_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function LocationRatePage$render$lambda_19($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function LocationRatePage$render$lambda_20($this$custom, version) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => Cents__toString$default_impl_dffhix($this$invoke.invoke_r7m7el_k$(version).transportTwoWay_1, VOID, true));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function LocationRatePage$render$lambda_21($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var LocationRatePageClass;
function LocationRatePage() {
  if (LocationRatePageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.rate_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationPrograms_g0oima_k$().get_6ueaa7_k$(new (ID())(this.id_1))));
        var tmp_0 = this;
        tmp_0.location_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_1())($this$remember.invoke_r7m7el_k$(this.rate_1).location_1))));
        var tmp_1 = this;
        tmp_1.plan_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplates_ojj53j_k$().get_6ueaa7_k$(new (ID_0())($this$remember.invoke_r7m7el_k$(this.rate_1).template_1))));
        var tmp_2 = this;
        tmp_2.dateds_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationProgramDateds_xnbfxu_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationProgramDated()), arrayOf([]), false));
          var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$2);
          var tmp_1 = eq(get_program(it), new (ID())(this.id_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(CareLocationProgramDated()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$9);
          this_0.descending_tl4o2_k$(get_start(get_activeRange(it_0)));
          var tmp$ret$5 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$5)));
        });
        var tmp_3 = this;
        tmp_3.currentDated_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.invoke_r7m7el_k$(this.dateds_1);
          var tmp$ret$11;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.activeRange_1.contains_pio7lx_k$(today())) {
                tmp$ret$11 = element;
                break $l$block;
              }
            }
            tmp$ret$11 = null;
          }
          return tmp$ret$11;
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.rate_1).name_1);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        var tmp_2 = LocationRatePage$render$lambda;
        keyValue(element_2, tmp_2, ($this$keyValue) => $this$keyValue.invoke_r7m7el_k$(this.location_1).name_1);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
        var label = LocationRatePage$render$lambda_0;
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_5 = sizeConstraints(get_centered(element_3), VOID, VOID, VOID, VOID, VOID, get_rem(10));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        element_4.set_themeChoice_py59um_k$(element_4.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_5, ($this$invoke) => label($this$invoke));
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_7 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_8 = get_unpadded(element_5);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Link())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_8.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        var tmp_6 = KMutableProperty0();
        var tmp_7 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_8 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_8, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.plan_1).name_1);
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        var tmp_9 = KMutableProperty0();
        var tmp_10 = Link$_get_to_$ref_jq7esp(element_6);
        var tmp_11 = getPropertyCallableRef('to', 0, tmp_9, tmp_10, Link$_set_to_$ref_i9gu5x(element_6));
        element_6.invoke_bnq13k_k$(tmp_11, ($this$invoke) => () => new (CareProgramTemplateDetailPage())($this$invoke.invoke_r7m7el_k$(this.plan_1)._id_1));
        element_6.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_9 = get_unpadded(shownWhen(element_5, false, VOID, LocationRatePage$render$lambda_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Button())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_9.willAddChild_hz2iwc_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (IconView())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        element_9.set_source_3o5lkf_k$(get_edit(Companion_getInstance_1()).resize_q1xpz0_k$(get_rem_0(1.25)));
        var tmp_12 = KMutableProperty0();
        var tmp_13 = IconView$_get_description_$ref_x7iif6(element_9);
        var tmp_14 = getPropertyCallableRef('description', 0, tmp_12, tmp_13, IconView$_set_description_$ref_rpvc1e(element_9));
        element_9.invoke_bnq13k_k$(tmp_14, LocationRatePage$render$lambda_2);
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        element_8.set_action_2ds022_k$(Action('Change', VOID, VOID, VOID, VOID, VOID, LocationRatePage$render$slambda(this, element_8)));
        element_8.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_8);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        var tmp_15 = LocationRatePage$render$lambda_3;
        keyValue(element_2, tmp_15, ($this$keyValue) => renderToString_0($this$keyValue.invoke_r7m7el_k$(this.rate_1).templateSince_1, RenderSize_Abbreviation_getInstance()));
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        element.willAddChild_hz2iwc_k$(element_10);
        element_10.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.currentDated_1) == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_10.willAddChild_hz2iwc_k$(element_11);
        element_11.set_vertical_nuap32_k$(true);
        var current = get_waitForNotNull(this.currentDated_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(element_11, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_11.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(true);
        styledHeader(element_12, LocationRatePage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (TextView())(element_12.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        element_12.willAddChild_hz2iwc_k$(element_13);
        element_13.set_themeChoice_py59um_k$(element_13.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_16 = KMutableProperty0();
        var tmp_17 = TextView$_get_content_$ref_4pzcwl(element_13);
        var tmp_18 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb(element_13));
        element_13.invoke_bnq13k_k$(tmp_18, LocationRatePage$render$lambda_5);
        element_13.onStartup_vrxh3i_k$();
        element_12.addChild_2qpft2_k$(element_13);
        element_12.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = themed(element_11, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_12.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (RowOrCol())(element_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_14.willAddChild_hz2iwc_k$(element_15);
        element_15.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_13 = themed(get_centered(element_15), ChipSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_14 = themed(this_13, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (TextView())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_14.willAddChild_hz2iwc_k$(element_16);
        var tmp_19 = KMutableProperty0();
        var tmp_20 = TextView$_get_content_$ref_4pzcwl(element_16);
        var tmp_21 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb(element_16));
        element_16.invoke_bnq13k_k$(tmp_21, LocationRatePage$render$lambda_6);
        element_16.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_16);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_15 = weight(element_15, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Space())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_15.willAddChild_hz2iwc_k$(element_17);
        element_17.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_16 = get_centered(element_15);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (TextView())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_16.willAddChild_hz2iwc_k$(element_18);
        var tmp_22 = KMutableProperty0();
        var tmp_23 = TextView$_get_content_$ref_4pzcwl(element_18);
        var tmp_24 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb(element_18));
        element_18.invoke_bnq13k_k$(tmp_24, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).rateInForceSince_kfs6_k$($this$invoke.invoke_r7m7el_k$(current).activeRange_1.toString()));
        element_18.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_18);
        element_15.onStartup_vrxh3i_k$();
        element_14.addChild_2qpft2_k$(element_15);
        var tmp_25 = LocationRatePage$render$lambda_7;
        keyValue(element_14, tmp_25, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).price_1, VOID, true));
        var tmp_26 = LocationRatePage$render$lambda_8;
        keyValue(element_14, tmp_26, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).transportOneWay_1, VOID, true));
        var tmp_27 = LocationRatePage$render$lambda_9;
        keyValue(element_14, tmp_27, ($this$keyValue) => Cents__toString$default_impl_dffhix($this$keyValue.invoke_r7m7el_k$(current).transportTwoWay_1, VOID, true));
        element_14.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_14);
        element_11.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element.willAddChild_hz2iwc_k$(element_19);
        element_19.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = themed(element, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_17.willAddChild_hz2iwc_k$(element_20);
        element_20.set_vertical_nuap32_k$(true);
        styledHeader(element_20, LocationRatePage$render$lambda_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (TextView())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        element_20.willAddChild_hz2iwc_k$(element_21);
        element_21.set_themeChoice_py59um_k$(element_21.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_28 = KMutableProperty0();
        var tmp_29 = TextView$_get_content_$ref_4pzcwl(element_21);
        var tmp_30 = getPropertyCallableRef('content', 0, tmp_28, tmp_29, TextView$_set_content_$ref_pketfb(element_21));
        element_21.invoke_bnq13k_k$(tmp_30, LocationRatePage$render$lambda_11);
        element_21.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_21);
        element_20.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_20);
        var tmp_31 = LocationRatePage$render$lambda_12;
        var tmp_32 = Companion_instance_0;
        var tmp_33 = LocationRatePage$render$lambda_13;
        var tmp_34 = tmp_32.text_y5ktm4_k$(tmp_33, 2.0, LocationRatePage$render$lambda_14);
        var tmp_35 = Companion_instance_0;
        var tmp_36 = LocationRatePage$render$lambda_15;
        var tmp_37 = tmp_35.custom_k0krgj_k$(tmp_36, 1.0, LocationRatePage$render$lambda_16);
        var tmp_38 = Companion_instance_0;
        var tmp_39 = LocationRatePage$render$lambda_17;
        var tmp_40 = tmp_38.custom_k0krgj_k$(tmp_39, 1.0, LocationRatePage$render$lambda_18);
        var tmp_41 = Companion_instance_0;
        var tmp_42 = LocationRatePage$render$lambda_19;
        table(element, this.dateds_1, tmp_31, [tmp_34, tmp_37, tmp_40, tmp_41.custom_k0krgj_k$(tmp_42, 1.0, LocationRatePage$render$lambda_20)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_18 = shownWhen(element, VOID, VOID, LocationRatePage$render$lambda_21);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (Space())(this_18.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_22);
        this_18.willAddChild_hz2iwc_k$(element_22);
        element_22.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_22);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'LocationRatePage', VOID, VOID, [Page()]);
    LocationRatePageClass = $;
  }
  return LocationRatePageClass;
}
//region block: exports
export {
  LocationRatePage as LocationRatePagecks6xwyzxx95,
};
//endregion

//# sourceMappingURL=LocationRatePage.mjs.map
